import { createActions } from 'helpers/actions'

const entityName = 'assetTolerancesOptions'

export default createActions(entityName, {
  entityUrl: 'assets/assetTolerances',
  useSelectionList: true,
})
